<template>
  <div>
    <!-- 筛选查询 -->
    <div class="wScreenArea">
      <el-card class="box-card">
        <div slot="header" class="wScreenCardHeader">
          <span>筛选查询</span>
        </div>
        <!-- 统计信息 -->
        <div class="stats-row">
          <div class="stat-item">
            <span class="stat-label">已核销数量</span>
            <span class="stat-value used">{{ stats.usedCount }}</span>
          </div>
          <div class="stat-item">
            <span class="stat-label">未核销数量</span>
            <span class="stat-value unused">{{ stats.unusedCount }}</span>
          </div>
          <div class="stat-item">
            <span class="stat-label">总数量</span>
            <span class="stat-value total">{{ stats.totalCount }}</span>
          </div>
        </div>
        <el-form
          label-position="left"
          label-width="90px"
          @submit.native.prevent
        >
          <el-row :gutter="20">
            <!-- <el-col :span="6">
              <el-form-item label="门店">
                <el-select
                  v-model="selectedStore"
                  placeholder="选择门店"
                  style="width: 100%"
                  @change="onStoreChange"
                >
                  <el-option
                    v-for="s in stores"
                    :key="s.id"
                    :label="s.name"
                    :value="s.id"
                  />
                </el-select>
              </el-form-item>
            </el-col> -->

            <el-col :span="6">
              <el-form-item label="时间范围">
                <el-date-picker
                  v-model="dateRange"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  style="width: 100%"
                />
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="门店">
                <el-select
                  v-model="selectedStore"
                  placeholder="选择门店"
                  style="width: 100%"
                  @change="onStoreChange"
                  clearable
                >
                  <el-option
                    v-for="s in stores"
                    :key="s.id"
                    :label="s.name"
                    :value="s.id"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="商品名称">
                <!-- <el-input
                  v-model.trim="goodsName"
                  placeholder="请输入商品名称"
                  clearable
                /> -->
                <el-select v-model="goodsName" placeholder="选择商品" filterable >
                  <el-option v-for="g in goodList" :key="g.id" :label="g.name" :value="g.name" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="手机号">
                <el-input
                  v-model.trim="phoneNumber"
                  placeholder="请输入核销手机号"
                  clearable
                />
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="是否使用">
                <el-select
                  v-model="selectedIfUsed"
                  placeholder="全部"
                  clearable
                  style="width: 100%"
                >
                  <el-option
                    v-for="item in ifUsedOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col
              :span="4"
              style="display: flex; align-items: center; gap: 8px"
            >
              <el-button @click="applyFilter">查询</el-button>
              <el-button @click="resetFilter">重置</el-button>
            </el-col>
          </el-row>
        </el-form>
      </el-card>
    </div>

    <!-- 核销列表 -->
    <div class="wTableArea">
      <el-table border :data="tableData" v-loading="loading">
        <el-table-column
          prop="storeName"
          label="门店"
          align="center"
        />
        <el-table-column
          prop="goodsName"
          label="商品名称"
          align="center"
        />
        <el-table-column
          prop="verificationUserPhone"
          label="核销员电话"
          align="center"
          width="130"
        />
        <el-table-column
          prop="userPhone"
          label="用户电话"
          align="center"
        />
        <el-table-column
          prop="redeemTime"
          label="核销时间"
          align="center"
          width="180"
        />
        <el-table-column
          prop="redeemCode"
          label="核销码"
          align="center"
          class-name="redeem-code-column"
        />
          <el-table-column 
                prop="status" 
                label="是否使用" 
                align="center" 
            >
                <template #default="{ row }">
                <el-tag :type="row.status === 'Y' ? 'warning' : 'success'">
                    {{ row.status === 'Y' ? '未使用' : '已使用' }}
                </el-tag>
                </template>
            </el-table-column>
      </el-table>

      <!-- 分页 -->
      <div class="wPagination">
        <el-pagination
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
          :current-page="pagination.current"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pagination.size"
          :total="pagination.total"
          layout="total, sizes, prev, pager, next, jumper"
        />
      </div>
    </div>
  </div>
</template>

<script>
import {
  getStoreManagerListApi,
  listVerificationCodeApi,
} from "@/network/wApi.js";
import { getBwcGoods } from "../../network/api";

export default {
  data() {
    return {
      selectedStore: "",
      stores: [],
      goodsName: "",
      phoneNumber: "",
      selectedIfUsed: "",
      dateRange: [],
      tableData: [],
      loading: false,
      ifUsedOptions: [
        { label: "未使用", value: "Y" },
        { label: "已使用", value: "N" },
      ],
      pagination: {
        current: 1,
        size: 10,
        total: 0,
      },
      stats: {
        usedCount: 0,
        unusedCount: 0,
        totalCount: 0,
      },
          goodList:null,
    };
  },
  mounted() {
    this.getStoreList();
    this.getGoodLisst();
  },
  methods: {
    // 获取门店列表
    getStoreList() {
      this.loading = true;
      let userInfo = localStorage.getItem("USER_INFO");
      let userId = "";
      if (userInfo) {
        try {
          userInfo = JSON.parse(userInfo);
          userId = userInfo.id || "";
        } catch (e) {}
      }

      getStoreManagerListApi({ userId })
        .then((res) => {
          if (res && Array.isArray(res)) {
            this.stores = res.map((store) => ({
              id: store.id,
              name: store.storeName,
            }));
          } else if (res && res.records && Array.isArray(res.records)) {
            this.stores = res.records.map((store) => ({
              id: store.id,
              name: store.storeName,
            }));
          } else {
            this.stores = [];
          }
          
          if (this.stores.length > 0) {
            this.selectedStore = this.stores[0].id;
          }
          
          this.fetchData();
        })
        .catch((err) => {
          console.error("获取门店列表失败:", err);
          this.stores = [];
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getGoodLisst() {
      getBwcGoods({
        ifBawangcan:1
      }).then((res) => {
        console.log(res);
        
        if(res){
          console.log(11111);
            
          this.goodList = res;
        }
      });
    },
    // 获取核销数据
    fetchData() {
      this.loading = true;

      const params = {
        current: this.pagination.current,
        size: this.pagination.size,
        verificationConfigId: '-1',
        goodsName: ""
      };

      if (this.selectedStore) {
        params.storeId = this.selectedStore;
      }

      if (this.dateRange && this.dateRange.length === 2) {
        params.startTime = this.formatDateTime(this.dateRange[0], "start");
        params.endTime = this.formatDateTime(this.dateRange[1], "end");
      }
      console.log(this.goodsName);
      
      if (this.goodsName) {
        params.goodsName = this.goodsName;
      }
      
      if (this.phoneNumber) {
        params.phoneNumber = this.phoneNumber;
      }

      if (this.selectedIfUsed) {
        params.ifUsed = this.selectedIfUsed;
      }
      console.log(params);
      
      listVerificationCodeApi(params)
        .then((res) => {
          const records = res.records || [];
          console.log(res);
          
          this.tableData = records.map((item) => this.formatTableRow(item));
          this.pagination.total =
            res && typeof res.total === "number" ? res.total : records.length;
          
          this.stats = {
            usedCount: res.usedCount || 0,
            totalCount: res.totalCount || this.pagination.total,
            unusedCount: (res.totalCount || this.pagination.total) - (res.usedCount || 0),
          };
        })
        .catch((err) => {
          console.error("获取核销数据失败:", err);
          this.tableData = [];
          this.pagination.total = 0;
          this.stats = { usedCount: 0, unusedCount: 0, totalCount: 0 };
        })
        .finally(() => {
          this.loading = false;
        });
    },

    // 核销码脱敏 (保留首尾各两位，中间用****代替)
    maskRedeemCode(code) {
      if (!code) return "-";
      const codeStr = String(code);
      if (codeStr.length <= 4) return codeStr;
      return codeStr.substring(0, 2) + "****" + codeStr.substring(codeStr.length - 2);
    },

    formatTableRow(item) {
      return {
        orderNo: item.orderId || item.orderNo || "-",
        storeName: item.storeName || "-",
        giftName: item.verificationName || item.giftName || "-",
        verificationUserPhone: this.maskPhone(
          item.verificationUserPhone || ""
        ),
        userPhone: this.maskPhone(
          item.userPhone || item.phoneNumber || item.phone || ""
        ),
        userPhoneNumber: item.userPhoneNumber || item.memberPhone || "-",
        status: item.status,
        redeemTime: item.verificationTime || item.redeemTime || "-",
        redeemCode: this.maskRedeemCode(item.verificationNumber || item.code || ""),
                goodsName: item.goodsName || "-"

      };
    },

    // 手机号脱敏
    maskPhone(phone) {
      if (!phone || phone.length < 7) return phone;
      return phone.substring(0, 3) + "****" + phone.substring(phone.length - 4);
    },

    // 日期格式化
    formatDateTime(date, type) {
      if (!date) return "";
      const d = new Date(date);
      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, "0");
      const day = String(d.getDate()).padStart(2, "0");
      const suffix = type === "end" ? "23:59:59" : "00:00:00";
      return `${year}-${month}-${day} ${suffix}`;
    },

    // 门店变化
    onStoreChange() {
      this.pagination.current = 1;
      this.fetchData();
    },

    // 查询
    applyFilter() {
      this.pagination.current = 1;
      this.fetchData();
    },

    // 重置
    resetFilter() {
      this.selectedStore = "";
      this.goodsName = "";
      this.phoneNumber = "";
      this.selectedIfUsed = "";
      this.dateRange = [];
      this.pagination.current = 1;
      this.fetchData();
    },

    // 分页
    handleSizeChange(val) {
      this.pagination.size = val;
      this.pagination.current = 1;
      this.fetchData();
    },
    handleCurrentChange(val) {
      this.pagination.current = val;
      this.fetchData();
    },
  },
};
</script>

<style lang="less" scoped>
@import "@/assets/css/publicStyle.less";

.wScreenCardHeader {
  display: flex;
  align-items: center;
}

.stats-row {
  display: flex;
  gap: 40px;
  padding: 10px 0 15px 0;
  border-bottom: 1px solid #ebeef5;
  margin-bottom: 15px;
}

.stat-item {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.stat-label {
  font-size: 14px;
  color: #606266;
  margin-bottom: 4px;
}

.stat-value {
  font-size: 24px;
  font-weight: bold;
  
  &.used {
    color: #67c23a;
  }
  
  &.unused {
    color: #e6a23c;
  }
  
  &.total {
    color: #409eff;
  }
}

/deep/ .redeem-code-column .cell {
  white-space: nowrap;
}
</style>
